import { layoutClasses } from 'src/layouts/classes';
import { cn } from '@/lib/utils';

// ----------------------------------------------------------------------

type MainProps = React.HTMLAttributes<HTMLElement> & {
  layoutQuery?: string;
};

export function Main({ className, children, layoutQuery, ...other }: MainProps) {
  return (
    <main
      className={cn(layoutClasses.main, 'flex flex-1 h-screen w-full', className)}
      {...other}
    >
      <div className="flex h-full w-full flex-col bg-background">
        {children}
      </div>
    </main>
  );
}
